module.exports = __webpack_public_path__ + "img/9788991780842.24200318.jpg";